module.exports = __webpack_public_path__ + "src/img/dxgg.0b6ad279.svg";